@if (noneMatchingFinishSelected) {
<div class="customizer-errors" [ngClass]="{'highlightChangesOverlay': false}">
	<customizer-changes [changes]="finishErrors" (changesChange)="handleChange($event)"></customizer-changes>
</div>
}

<customizer-component-header2 [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)" style="user-select: none; min-height: 100%;">
	<div additional class="temple-type-buttons">
		@for (templeType of templeTypes; track $index) {
		<button class="btn btn-secondary mr-1 mb-3" [ngClass]="{'toggled': templeType === activeTempleType}" (click)="filterTempleTypeDisplay(templeType)">
			{{templeType.replace(' temples', '')}}
		</button>
		}
	</div>

	<div main id="select-box-container">
		@for (group of groups; track $index) {
		@if (getState(group) === 'collapse') {
		<select-box-item
			class="customizer-item"
			[attr.id]="(group && group.selectedDesign && group.selectedDesign.Uuid)"
			[ngClass]="{'is-selected': getSelectedVariant !== null && (group && group.selectedDesign && group.selectedDesign.Id === getSelectedVariant.Id)}"
			[optionsDiscontinued]="optionsDiscontinued"
			[optionsText]="optionsText"
			[option]="group.selectedDesign"
			[selected]="getSelectedVariant !== null && (group && group.selectedDesign && group.selectedDesign.Id === getSelectedVariant.Id)"
			[optionsImage]="getImage"
			[imageClass]="imageClass"
			[currentColor]="currentColor"
			[variantOrModelIsNew]="variantOrModelIsNew"
			[user]="user"
			[hasSubItems]="group.designs.length > 1"
			(click)="group.designs.length > 1 ? expandGroup(group) : onSelected(group.selectedDesign, group)"
		>
		</select-box-item>
		}

		@if (group.designs.length > 0) {
			<div class="back">
				<div [@submenuAnim]="getState(group)">
					<div class="temple-group-header" (click)="collapseGroup(group)">
						{{group.name}}
						<div class="small">
							{{ 'COMMON.ACTIONS.COLLAPSE' | translate }}
							<i class="fa-light fa-angle-up"></i>
						</div>
					</div>

					<select-box
						[editMode]="state === customizerStateEnum.EDITORDER"
						[imageClass]="'temple'"
						[optionsImage]="getImage"
						[options]="group.designs"
						optionsText="Description"
						optionsId="Id"
						[selected]="getSelectedVariant"
						(selectedChange)="onSelected($event, group)"
						[optionsDiscontinued]="'Discontinued'"
						[colorMatchMode]="true"
						[colorsAvailableForMatching]="allPossibleColorsOnOtherSelectedVariants"
						[currentColor]="getSelectedVariant.VariantColor"
						[variantOrModelIsNew]="modelIsNew"
						[matchColor]="menu.matchColor"
						[isAccordion]="true"
					>
					</select-box>
				</div>
			</div>
		}
		}
	</div>
</customizer-component-header2>
